import askGithub from './../lib/askGithub'
import parseGithubApiV3Response from './../lib/parseGithubApiV3Response'

/**
 * Create a repository
 * @param {string} authToken
 * @param {string} newName
 * @param {string} ownerId
 * @returns {Promise<Repository>}
 */
async function createRepository(authToken, newName, ownerId){
  // The ownerId may be the current user or one of the user's orgs
  var result = await askGithub(authToken, `query{
    viewer {
      id
    }
  }`)
  if (result['data']['viewer']['id'] == ownerId){
    // This is to be created under the users own repos

    var apiUrl = `https://api.github.com/user/repos`



  } else {
    // Else check that its an org
    var result = await askGithub(authToken, `query{
      node(id:"${ownerId}"){
        ...on Organization  {
          id
          login
        }
      }
    }`)
    if (!result['data']['node']['id']){
      throw new Error(`The 'ownerId' is not the current user or an organisation
        the user is linked to.`.replace(/\s+/g, ' '))
    }
    // The repo is to be created under an org

    var apiUrl = `https://api.github.com/orgs/${result['data']['node']['login']}/repos`


  }


  var result = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      "name": newName,
      "private": true,
      "auto_init": true,
    })
  })
  .then(parseGithubApiV3Response)
  return {
    id: result['node_id'],
    ownerId: result['owner']['node_id'],
    name: result['name'],
    updatedAt: result['updated_at'],
  }
}

export default createRepository


// WEBPACK FOOTER //
// ./src/data/createRepository.js